
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/foam/signup",
      function () {
        return require("private-next-pages/foam/signup/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/foam/signup"])
      });
    }
  